import React, { useEffect, useState, useRef } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { supabase } from '../../lib/supabase';
import { useAuth } from '../../contexts/AuthContext';
import './SuccessPage.css';

const SuccessYearly = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const { user, loading: authLoading } = useAuth();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const hasProcessed = useRef(false); // Protection contre les appels multiples

  useEffect(() => {
    // Attendre que l'AuthContext soit chargé
    if (authLoading) {
      return;
    }

    // Si déjà traité, ne pas refaire le traitement
    if (hasProcessed.current) {
      return;
    }

    const sessionId = searchParams.get('session_id');
    
    // Si pas d'utilisateur connecté, rediriger vers l'authentification
    if (!user) {
      setError('Vous devez être connecté pour activer votre abonnement.');
      setLoading(false);
      return;
    }

    // Marquer comme en cours de traitement
    hasProcessed.current = true;

    const saveSubscription = async () => {
      try {
        console.log('Début de la création d\'abonnement annuel...');
        
        // Vérifier si l'abonnement existe déjà
        const { data: existingSubscription } = await supabase
          .from('user_infos')
          .select('*')
          .single();

        if (existingSubscription?.subscription_id) {
          console.log('Abonnement déjà existant');
          setLoading(false);
          return;
        }

        // Créer l'abonnement annuel en utilisant la fonction RPC
        const startDate = new Date();
        const endDate = new Date();
        endDate.setFullYear(endDate.getFullYear() + 1);

        console.log('Appel de create_user_subscription...');
        const { data, error } = await supabase
          .rpc('create_user_subscription', {
            param_subscription_type: 'yearly',
            param_start_date: startDate.toISOString(),
            param_end_date: endDate.toISOString(),
            param_is_active: true,
            param_amount_paid: 100.00,
            param_stripe_subscription_id: sessionId || null
          });

        if (error) {
          throw error;
        }

        console.log('Abonnement annuel créé avec succès:', data);
        setLoading(false);
        
        // Rediriger vers l'app après 3 secondes
        setTimeout(() => {
          navigate('/app');
        }, 3000);

      } catch (err) {
        console.error('Erreur lors de la création de l\'abonnement:', err);
        setError(err.message);
        setLoading(false);
        // Remettre à false en cas d'erreur pour permettre un retry
        hasProcessed.current = false;
      }
    };

    saveSubscription();
  }, [authLoading, user]); // Dépendances simplifiées

  // Affichage pendant le chargement de l'auth
  if (authLoading) {
    return (
      <div className="success-page">
        <div className="success-content">
          <h1>Chargement...</h1>
          <p>Vérification de votre session...</p>
        </div>
      </div>
    );
  }

  if (loading) {
    return (
      <div className="success-page">
        <div className="success-content">
          <h1>Traitement en cours...</h1>
          <p>Nous activons votre abonnement annuel.</p>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="success-page">
        <div className="success-content">
          <h1>Erreur</h1>
          <p>Une erreur est survenue: {error}</p>
          <div className="error-actions">
            <button onClick={() => navigate('/app')}>
              Aller à l'application
            </button>
            <button onClick={() => navigate('/')}>
              Retour à l'accueil
            </button>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="success-page">
      <div className="success-content">
        <div className="success-icon">✓</div>
        <h1>Abonnement annuel activé !</h1>
        <p>Votre abonnement annuel à 100,00€ a été activé avec succès.</p>
        <p>Vous allez être redirigé vers l'application dans quelques secondes...</p>
        <button onClick={() => navigate('/app')}>
          Accéder à l'application
        </button>
      </div>
    </div>
  );
};

export default SuccessYearly; 